import '../../css/sections/AchievementsSection.css';
import { motion } from "framer-motion";
import { TextGenerateEffect } from "../ui/text-generate-effect";
// import root from '../../root.css';

function TimelineSection() {

    return (
        <motion.div id='works' className={`achievements-container`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true, amount: 0.04 }}>
            <div className='achievements-text'>
                <div className='achievements-heading'>
                    <h1>BUILT TO <span className='special-font' style={{ fontStyle: "italic" }}>WIN</span></h1>
                    <TextGenerateEffect
                        words="From Competitive Victories To Professional Certifications, Each Recognition Represents Countless Hours Of Dedication, The Relentless Pursuit Of Excellence And Outworking Everyone."
                    />
                </div>
            </div>
            <div className='achievements-section'>
                <div className='achievements-items'>
                    <div className='achievements-item'>
                        <h1>iNOVEum Business Accelerator</h1>
                        <p>Program For Young Entrepreneurs Focused On Startups And Business Creation. Placed 4th In Final And Received A 250€ Grant For Further Business Development. Also Honored With The Public's Choice Award. Developed An MVP Prototype, Acquired Early Customers, And Led Marketing And Promotion Efforts To Grow The Project.</p>
                        <img src="/images/inoveum_final_2.jpg" style={{ paddingLeft: "2rem", paddingRight: "2rem" }} alt="iNOVEum Business Accelerator" />
                    </div>
                    <div className='achievements-item2'>
                        <h1>Cambridge FCE B2 Certificate</h1>
                        <p>Internationally Recognized Certificate Proving Upper-Intermediate English Proficiency For Academic And Professional Use.</p>
                        <img src="/images/fce_certificate.jpg" style={{ width: "82%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="Cambridge FCE B2 Certificate" />
                    </div>
                </div>
                <div className='achievements-items'>
                    <div className='achievements-item2'>
                        <h1>OKM Certificate 25</h1>
                        <p>Critical Thinking And Argumentation Competition For High School Students. Placed 75th Overall Out Of 1771 Participants From All Regions And 15th Out Of 432 Participants In My Region. The Competition Assessed Reading Comprehension, Argumentation, Fact-Finding, And Critical Evaluation Of Sources.</p>
                        <img src="/images/okm_certificate.png" style={{ width: "69%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="OKM Certificate" />
                    </div>
                    <div className='achievements-item'>
                        <h1>AMAVET Science</h1>
                        <p>Nationwide Competitive Exhibition Of Scientific-Technical Projects By High School Students. Advanced To The National Final, Competing Among The Top 60 Projects From Across The Country. I Prepared An Exhibition Panel, Which Visitors And The Expert Committee Viewed During The Event.</p>
                        <img src="/images/amavet_national_round.jpg" style={{ width: "100%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="AMAVET Science" />
                    </div>
                </div>
                <div className='achievements-items'>
                    <div className='achievements-item'>
                        <h1>Technical Idea of the Year</h1>
                        <p>Advanced To The National Finals Of The Technical Idea Of The Year Competition At The University Of Žilina (UNIZA). Where I Presented And Defended My Research Before An Expert Committee. Ranked Among The Top 13 Projects Nationwide.</p>
                        <img src="/images/tmr.jpg" style={{ width: "100%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="iNOVEum Business Accelerator" />
                    </div>
                    <div className='achievements-item2'>
                        <h1>OKM Certificate 26</h1>
                        <p>Critical Thinking And Argumentation Competition For High School Students. Placed 93rd Overall Out Of 2189 Participants From All Regions And 16th Out Of 407 Participants In My Region. The Competition Assessed Reading Comprehension, Argumentation, Fact-Finding, And Critical Evaluation Of Sources.</p>
                        <img src="/images/okm_certificate2.png" style={{ width: "63%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="OKM Certificate" />
                    </div>
                </div>
                <div className='achievements-items'>
                </div>
                <div className='achievements-items'>
                    <div className='achievements-item'>
                        <h1>SOČ Professional Activity</h1>
                        <p>A Nationwide Academic Competition For Talented High School Students. I Developed A Project And Made A Written Research Paper Which I Oral Defensed Before An Expert Committee. Placed 4th In Regional Round In Mechanics And Engineering Category.</p>
                        <img src="/images/soc_regional_round.jpg" style={{ width: "100%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="SOČ - High School Professional Activity" />
                    </div>
                    <div className='achievements-item2'>
                        <h1>Mensa IQ Certificate</h1>
                        <p>Recognized For Exceptional Cognitive Abilities And Intellectual Potential. Achieved A 132 IQ Score That Places Me Among The Top 2% Of The Population.</p>
                        <img src="/images/iq.png" style={{ width: "50%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="IQ Certificate" />
                    </div>
                    {/* <div className='achievements-item2'>
                        <h1>IT Fitness Test Certificate</h1>
                        <p>Nationwide Testing Of IT Skills And Digital Competencies For High School Students, Assessing Proficiency In Computer Science And Information Technology.</p>
                        <img src="/images/it_fitness_certificate.png" style={{ width: "100%", paddingLeft: "2rem", paddingRight: "2rem" }} alt="IT Fitness Test Certificate" />
                    </div> */}
                </div>
                <div className='achievements-items'>
                    <div className='achievements-item3'>
                        <h1>CCNA Certificates</h1>
                        <p>Certified in Cisco Networking Fundamentals, Demonstrating Proficiency In Network Installation, Operation, And Troubleshooting.</p>
                        <div className='achievements-images'>
                            <img src="/images/ccna_certificate.png" style={{ width: "40%" }} alt="CCNA Certificate" />
                            <img src="/images/ccna2_certificate.png" style={{ width: "40%" }} alt="CCNA2 Certificate" />
                        </div>
                        <div className='achievements-images2'>
                            <img src="/images/ccna3_certificate.png" style={{ width: "40%" }} alt="CCNA3 Certificate" />
                            <img src="/images/it_certificate.png" style={{ width: "40%" }} alt="IT Certificate" />
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default TimelineSection;
